import type { ui as Fr } from '../fr/ui';

/** « ui » in English — typed on the French: a missing sentence does not compile. */
export const ui: typeof Fr = {
  appeler: (nom) => `Call ${nom}`,
  traceTitre: 'An operation was not recorded in the audit log',
  traceDebut: 'The operation itself went through, but ',
  traceGras: 'its record could not be written',
  traceSuite: '. Further operations are blocked until the audit log responds.',
  tracePrevenez: ' Tell the owner',
  traceFin: ': what was just done must be noted down before you continue.',
  horsLigne: 'Offline mode — your entries will sync when the network is back',
  serveurTitre: 'The server is not responding',
  serveurTexte: 'Your device is connected, but the software cannot reach the server. Screens may stay empty until the connection is restored.',
  serveurRienPerdu: ' Nothing is lost',
  serveurFin: ': none of your saved entries are affected.',
};
